import './MarkerInfoItem.css';
import React from 'react';
import { getDictionaryItem, getGlobalDictionaryTerm } from '../../../../utils';
import FavouriteBtn from '../../FavouriteBtn/FavouriteBtn';
import LazyPicture from '../../LazyPicture';
import RouterLink from '../../RouterLink';
import CarouselProvider from '../../CarouselProvider/CarouselProvider';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../../utils/tealium';
import { SitecoreContextReactContext } from '../../../../utils/SitecoreContextReactContext';
const MarkerInfoItem = _ref => {
  let {
    englishTitle,
    title,
    introText,
    tripadvisorImage,
    tripadvisorReviews,
    objectID,
    category,
    image,
    url,
    mediaAssets,
    color,
    rtl,
    dictionary,
    analytics,
    params,
    activeTopPicks,
    toggleActiveTopPicks
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const learnMoreDictionary = getDictionaryItem(dictionary, 'learnMore') || 'learnMore';
  const reviewDictionary = getDictionaryItem(dictionary, 'review') || 'review';
  const reviewsDictionary = getDictionaryItem(dictionary, 'reviews') || 'reviews';
  const addToFavorites = getGlobalDictionaryTerm(sitecoreContext, 'addToFavorites') || 'add To Favorites';
  const removeFromFavorites = getGlobalDictionaryTerm(sitecoreContext, 'removeFromFavorites') || 'remove from Favorites';
  const renderItems = () => {
    if (mediaAssets && mediaAssets.urls && mediaAssets.urls.length) {
      return mediaAssets.urls.map((src, index) => /*#__PURE__*/React.createElement(LazyPicture, {
        useEmptyPlaceholder: true,
        key: `${index}-${src}`,
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 768px)",
        srcSet: src
      }), /*#__PURE__*/React.createElement("img", {
        className: "marker-info-item__image",
        src: src,
        alt: title || englishTitle,
        "aria-hidden": "true"
      })));
    }
    return [];
  };
  const nextIcon = /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.18",
    height: "9",
    viewBox: "0 0 5.18 9",
    className: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_chevron-right",
    d: "M9,.573H9L4.5,5.18,0,.573A1.9,1.9,0,0,1,2.692.542l.031.031L4.5,2.392h0L6.276.573A1.9,1.9,0,0,1,8.969.542Z",
    transform: "translate(0 9) rotate(-90)",
    fill: "#035e88"
  }));
  const prevIcon = /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.18",
    height: "9",
    viewBox: "0 0 5.18 9",
    className: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_chevron-right",
    d: "M9,4.606H9L4.5,0,0,4.606a1.9,1.9,0,0,0,2.692.031l.031-.031L4.5,2.788h0L6.276,4.606a1.9,1.9,0,0,0,2.692.031Z",
    transform: "translate(0 9) rotate(-90)",
    fill: "#035e88"
  }));
  const renderCarousel = () => {
    return /*#__PURE__*/React.createElement(CarouselProvider, null, _ref2 => {
      let {
        renderCarousel,
        renderPreviousButton,
        renderNextButton,
        renderDots,
        state
      } = _ref2;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "marker-info-item__img-wrapper"
      }, renderCarousel(renderItems(), {
        responsive: {
          desktop: {
            breakpoint: {
              max: 10000,
              min: 1200
            },
            items: 1
          },
          tabletLarge: {
            breakpoint: {
              max: 1199,
              min: 768
            },
            items: 1
          },
          tablet: {
            breakpoint: {
              max: 767,
              min: 480
            },
            items: 1
          },
          mobile: {
            breakpoint: {
              max: 479,
              min: 0
            },
            items: 1
          }
        },
        containerClass: ''
      }), /*#__PURE__*/React.createElement("div", {
        className: "marker-info-item__type"
      })), /*#__PURE__*/React.createElement("div", {
        className: `marker-info-item__btn marker-info-item__btn-prev ${rtl ? 'btn-group-rtl' : ''}`
      }, renderPreviousButton(() => tealiumClickFunc(tealiumMergeClickData(analytics['popupSliderAnalytics'], params), [title || englishTitle, 'previous']), true, false, prevIcon)), /*#__PURE__*/React.createElement("div", {
        className: `marker-info-item__btn marker-info-item__btn-next ${rtl ? 'btn-group-rtl' : ''}`
      }, renderNextButton(() => tealiumClickFunc(tealiumMergeClickData(analytics['popupSliderAnalytics'], params), [title || englishTitle, 'next']), true, false, nextIcon)), /*#__PURE__*/React.createElement("div", {
        className: "marker-info-item__dots"
      }, renderDots(() => tealiumClickFunc(tealiumMergeClickData(analytics['popupNavigatorBubblesAnalytics'], params), title || englishTitle))));
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: ` ${commonStyles}  ${rtl ? rtlStyles : ltrStyles}`
  }, /*#__PURE__*/React.createElement("div", {
    className: `marker-info-item`,
    style: {
      '--m114-marker-info-item': color
    }
  }, mediaAssets && mediaAssets.urls && mediaAssets.urls.length ? renderCarousel() : /*#__PURE__*/React.createElement("div", {
    className: "marker-info-item__img-wrapper"
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: image
  }), /*#__PURE__*/React.createElement("img", {
    className: "marker-info-item__image",
    src: image,
    alt: title || englishTitle,
    "aria-hidden": "true"
  })), /*#__PURE__*/React.createElement("div", {
    className: "marker-info-item__type"
  })), /*#__PURE__*/React.createElement("div", {
    className: "marker-info-item__info"
  }, category && /*#__PURE__*/React.createElement("span", {
    className: "category"
  }, category), (title || englishTitle) && /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, title || englishTitle), introText && /*#__PURE__*/React.createElement("span", {
    className: "description ellipsis2"
  }, introText), tripadvisorImage && /*#__PURE__*/React.createElement("div", {
    className: "imfilters-listing-item__tripadvisor"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tripadvisor-svg"
  }, /*#__PURE__*/React.createElement("img", {
    src: tripadvisorImage,
    alt: title || englishTitle,
    "aria-hidden": "true"
  })), tripadvisorReviews && /*#__PURE__*/React.createElement("span", {
    className: "tripadvisor-num"
  }, tripadvisorReviews, " ", Number(tripadvisorReviews) > 0 ? reviewsDictionary : reviewDictionary)), url && /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    href: url,
    onClick: () => tealiumClickFunc(tealiumMergeClickData(analytics['popupButtonAnalytics'], params), [title || englishTitle, learnMoreDictionary]),
    title: title,
    className: "btn btn-primary btn-primary--large learn-more-btn"
  }, learnMoreDictionary)), /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: objectID,
    classes: 'imfilters-listing-item__fav-btn',
    activeListOnSamePage: activeTopPicks,
    multiplyButton: true,
    analyticsClick: e => {
      if (e === 'add to favorites') {
        tealiumClickFunc(tealiumMergeClickData(analytics['popupFavoriteAnalytcis'], params), [title || englishTitle, addToFavorites]);
      } else {
        tealiumClickFunc(tealiumMergeClickData(analytics['popupFavoriteAnalytcis'], params), [title || englishTitle, removeFromFavorites]);
      }
      toggleActiveTopPicks(objectID);
    }
  })));
};
const commonStyles = "ckea4e3";
const ltrStyles = "l1jvkpow";
const rtlStyles = "rtdiqvk";
export default MarkerInfoItem;